export enum VehicleClaimSubstates {
    NONE = "NONE",
    COVERAGE_EVALUATION = "COVERAGE_EVALUATION",
    PENDING_ENTRY_WORKSHOP = "PENDING_ENTRY_WORKSHOP",
    NO_ENTRY_WORKSHOP = "NO_ENTRY_WORKSHOP",
    PENDING_DOCUMENTS = "PENDING_DOCUMENTS",
    BUDGETING = "BUDGETING",
    IN_REPAIR = "IN_REPAIR",
    TOTAL_LOST_PROCEDURE = "TOTAL_LOST_PROCEDURE",
    ASSUMED_BY_DEDUCIBLE = "ASSUMED_BY_DEDUCIBLE",
    COVERAGE_EVALUATION_BROKEN_GLASS = "COVERAGE_EVALUATION_BROKEN_GLASS",
    INSURED_ATTENDED_BROKEN_GLASS = "INSURED_ATTENDED_BROKEN_GLASS",
    COVERAGE_EVALUATION_TOTAL_THEFT = "COVERAGE_EVALUATION_TOTAL_THEFT",
    INSURED_ATTENDED_TOTAL_THEFT = "INSURED_ATTENDED_TOTAL_THEFT",
    AWAITING_CONFIRMATION_TO_REPAIR = "AWAITING_CONFIRMATION_TO_REPAIR",
}

export const REGISTRY_STEP = "REGISTRY_STEP";
export const COVERAGE_APPROVAL_STEP = "COVERAGE_APPROVAL_STEP";
export const PENDING_ENTRY_WORKSHOP_STEP = "PENDING_ENTRY_WORKSHOP_STEP";
export const DAMAGE_QUOTE_STEP = "DAMAGE_QUOTE_STEP";
export const VEHICLE_UNDER_REPAIR_STEP = "VEHICLE_UNDER_REPAIR_STEP";
export const TOTAL_LOST_PROCEDURE_STEP = "TOTAL_LOST_PROCEDURE_STEP";
export const TOTAL_THEFT_PROCEDURE_STEP = "TOTAL_THEFT_PROCEDURE_STEP";
